import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {CdBasicConfigPage} from "../page/overview/cd-basic-config/cd-basic-config.page";


const cdModuleEntry: TestModuleDefinition = {
    key: 'cd',
    label: 'Contact (cd)',
    components: [
        {
            key: 'BasicConfigPage',
            component: CdBasicConfigPage,
            selector: 'cd-config',
            type: 'PageComponent',
            label: 'basic config page'
        }
    ]
}

export const CD_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: cdModuleEntry, multi: true}
];
